<div class="u-shadow-mini {{ sectionclass }}" style="position: relative;">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap primary-color-bg"
		>
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }} {{ timezone }}</h5>
			</div>
		</div>
		<div class="analytics-portlet-content" style="min-height: 100px;">
			<div class="chart-div" *ngIf="hasData">
				<div id="chartElement"></div>
			</div>
			<div class="map-no-data" *ngIf="!hasData">No Data to Display</div>
		</div>
	</div>
</div>
